/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thriller_Nav_BadgeInputs */

const en_thriller_nav_badge = /** @type {(inputs: Thriller_Nav_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halloween`)
};

/**
* | output |
* | --- |
* | "Halloween" |
*
* @param {Thriller_Nav_BadgeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const thriller_nav_badge = /** @type {((inputs?: Thriller_Nav_BadgeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thriller_Nav_BadgeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_thriller_nav_badge(inputs)
});
export { thriller_nav_badge as "thriller.nav_badge" }